import { Flex } from 'components/primitives/flex';
import { useAtomValue } from 'jotai';
import styled from 'styled-components';
import { durationHoursAtom } from '../filterStore';
import { renderAtomCheckButton } from '../fields/AtomCheckButton';

export default function DurationFilterContent() {
  const durations = useAtomValue(durationHoursAtom);
  return <DurationWrapper gap="20px">{durations.map(renderAtomCheckButton)}</DurationWrapper>;
}

const DurationWrapper = styled(Flex)`
  max-width: 272px;
  flex-wrap: wrap;
  & > div {
    width: 46%;
  }
`;

export function DurationFilterContentInOtherFilters() {
  const durations = useAtomValue(durationHoursAtom).map((item) => ({
    ...item,
    label: item.label.split(' ')[0],
  }));
  return <DurationWrapperSmall gap="16px">{durations.map(renderAtomCheckButton)}</DurationWrapperSmall>;
}

const DurationWrapperSmall = styled(Flex)`
  flex-wrap: nowrap;
  width: 100%;
`;
